import { useEffect, useState, useRef } from "react";
// import "./OurPackagesPageCss/PackageDetailsModal.css";

// import { useCart } from "../../Contexts/Cart.contexts";

import { IoIosArrowDropdown } from "react-icons/io";
import { useCart } from "../../Contexts/Cart.contexts";

export default function ViewPackageDetails({ isOpen, onClose, packageData }) {
  const { addToCart } = useCart();

  const [expandedTests, setExpandedTests] = useState([]);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (packageData?.list) {
      setExpandedTests(Array(packageData.list.length).fill(false));
    }
  }, [packageData]);

  const toggleTest = (index) => {
    setExpandedTests((prev) =>
      prev.map((item, i) => (i === index ? !item : item))
    );
  };

  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose(); // close when clicked outside
    }
  };

  if (!isOpen || !packageData) return null;

  const handleAddToCart = () => {
    addToCart({
      id: Date.now().toString() + Math.random().toString(36).substr(2, 5),
      product: packageData.service_name,
      // components: packageData.tests,
      price: packageData.price,
      quantity: 1,
    });
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-details" ref={modalRef}>
        <div
          style={{
            color: "#0fb7a4",
            marginTop: "-20px"
          }}
        >
          <h2>{packageData?.service_name || "NA"}</h2>
          <hr
            style={{
              border: "none",
              borderBottom: "1px solid #e0e0e0",
              margin: "0.5rem 0 1rem 0",
            }}
          />
        </div>

        {packageData.list?.length > 0 ? (
          <div className="test-details">
            {packageData?.list.map((test, index) => (
              <div key={index} className="test-item">
                <div
                  className="test-header"
                  onClick={() => toggleTest(index)}
                  style={{ color: "grey" }}
                >
                  {test?.service_name}
                  <span className="dropdown-icon">
                    {expandedTests[index] ? "▲" : "▼"}
                  </span>
                </div>
                {expandedTests[index] && (
                  <div
                    className="test-description"
                    style={{ color: "#858080ff" }}
                  >
                    <p>
                      <strong>Department:</strong> {test.Department}
                    </p>
                    <p>
                      <strong>Report Time:</strong> {test.ReportTimeInDays}{" "}
                      day(s)
                    </p>
                    <p>
                      <strong>Preparation:</strong> {test.service_preperation}
                    </p>
                    <p>
                      <strong>Service Key:</strong> {test.service_key}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: "gray" }}>
            No detailed test information available.
          </p>
        )}

        <div className="modal-buttons">
          <button onClick={onClose} className="rbdButton reset-Btn">
            {" "}
            <span className="btn-text">Close</span>
          </button>
          <button className=" rbdButton" onClick={handleAddToCart}>
            <span className="btn-text">Add To Cart</span>{" "}
          </button>
        </div>
      </div>
    </div>
  );
}
